export default {
  getListDocument (state) {
    return state.documents
  },
  getDocument (state) {
    return state.document
  },
  getTotal (state) {
    return state.total
  },
  getLastPage (state) {
    return state.last_page
  },
  getOpenView (state) {
    return state.open_view
  },
  getOpenCreateChildren (state) {
    return state.open_create_children
  },
  getOpenEdit (state) {
    return state.open_edit
  },
  getOpenDocument (state) {
    return state.open_document
  }
}



// WEBPACK FOOTER //
// ./src/store/module/document/getters.js